// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".site_links_Eb\\+Di{border-top:1px solid var(--cp-gray-4);margin:3.2rem 0 0;padding:3.2rem 0 0}@media only screen and (min-width:1264px){.site_links_Eb\\+Di li{padding:0 2.6rem 2.4rem}.site_links_Eb\\+Di li a{align-items:center;color:var(--cp-black);display:flex;font-size:1.6rem;line-height:2.2rem;min-height:3.2rem}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"site_links": "site_links_Eb+Di"
};
module.exports = ___CSS_LOADER_EXPORT___;
